import { NavigationLink } from '@ebeihilfe/core';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'responsiveFilter',
  standalone: true,
})
export class ResponsiveFilterPipe implements PipeTransform {
  public transform(items: NavigationLink[]): NavigationLink[] {
    if (!items) {
      return items;
    }
    return items.filter((item) => item.itemType !== 'icon');
  }
}
